import axios from "axios";

export default () => {
	let headersToUse = {
		"Accept": "application/json;odata=verbose",
		"Content-Type": "application/json",
	};

	return axios.create({
		baseURL:"https://maps.googleapis.com/maps/api/geocode/",
		withCredentials: false,
		headers: headersToUse
	});
};